<template>
  <div class="full video-popup">
    <div class="closer" @click="() => { $emit('close') }"></div>

    <div class="close-row">
      <img src="./img/close.svg" @click="() => { $emit('close') }" />
    </div>
    <div class="video-section">
      <iframe width="880" height="560" :src="embed + '&autoplay=1'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    embed: {}
  }
}
</script>

<style scoped>
.closer{
  position: absolute;
  top:0px;
  left:0px;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.full{
  width: 100%;
  height: 100%;
}

.close-row{
  margin-top: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-popup{
  width: 100%;
  height: 100%;
  background-color: rgba(6, 12, 38, 0.9);
}

.popup-row{
  transform: scale(0.9);
  height: 100%;
  width: 100%;
  position: relative;
}
.video-section{
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Landing/VideoPopUp.vue